<template>
  <v-card
    class="expande-horizontal pa-3 card-balance-style"
    style="flex-wrap: wrap; border-radius: 12px;"
  >
    <div class="expande-horizontal column" style="flex-wrap: nowrap;">
      <span class="mb-3 fonte white--text" :style="`font-size: 12px;`">
        Meu Link de Indicação
      </span>

      <div style="width: 100%" class="expande-horizontal mb-2 pb-1 pt-0">
        <v-chip style="width: 100%; border-radius: 3px;">
          <input
            id="foo"
            :value="myLink"
            class="fonte"
            readonly
            style="margin-left: -13px; color: #555; min-width: 600px !important; border: none !important; border-radius: 1px; padding: 5px; height: 40px; margin-right: 6px;"
          />
        </v-chip>
        <button
          class="btn1 ml-2"
          icon
          @click="
            createGlobalMessage({
              type: 'success',
              message: 'Link copiado com sucesso!',
              timeout: 3000
            })
          "
          data-clipboard-target="#foo"
          style="background-color: yellow;border-radius: 50%;min-width: 40px; min-height: 40px; max-width: 40px; max-height: 40px;"
        >
          <v-icon color="black">mdi-content-copy</v-icon>
        </button>
      </div>
      <!-- <v-icon>mdi-cash-multiple</v-icon> -->
      <div class="expande-horizontal">
        <v-btn color="yellow" small dark>
          <span class="text-capitalize black--text"> Link Ativo</span>
        </v-btn>
      </div>
    </div>

  </v-card>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ClipboardJS from "clipboard";

export default {
  data() {
    return {
      myLink: ""
    };
  },
  computed: {
    ...mapGetters(["getLoggedUser"])
  },
  methods: {
    ...mapActions(["createGlobalMessage"]),
    linkMount() {
      // this.myLink = `https://${process.env.VUE_APP_DOMAIN}/#/${this.getLoggedUser.nickname}`;
      // this.myLink = `https://app.scnrevolution.com.br/#/${this.getLoggedUser.nickname}-000${this.getLoggedUser.id_user}`;
      this.myLink = `https://invest-demo-3.web.app/#/${this.getLoggedUser.nickname}-000${this.getLoggedUser.id_user}`;
      new ClipboardJS(".btn1");
    }
  },
  mounted() {
    this.linkMount();
  }
};
</script>
